import { Link } from "react-router-dom";
import { Check, Lock, Coins } from "lucide-react";
import { Button } from "../ui/button";
import { useReveal } from "../../lib/animations";

const features = [
  "Volledige heatmap-analyse",
  "Concrete onderhandelingstips",
  "PDF-rapport (downloadbaar)",
  "Geen abonnement, eenmalige betaling",
  "30 dagen toegang tot je rapport",
];

const bundleFeatures = [
  "3 analyses voor 1 e-mailadres",
  "Alles uit het standaardpakket",
  "Credits 12 maanden geldig",
  "Ideaal om offertes te vergelijken",
];

const methods = ["Bancontact", "iDEAL", "Visa", "Mastercard", "Apple Pay", "Google Pay"];

export default function PricingSection() {
  const ref = useReveal();
  return (
    <section data-testid="pricing-section" className="oc-section bg-oc-subtle">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-5xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            <span className="w-1.5 h-1.5 rounded-full bg-oc-fair" />
            Eerlijk geprijsd
          </span>
          <h2 className="font-display font-bold text-oc-primary text-[30px] sm:text-[38px] lg:text-[42px] leading-tight tracking-tight mt-3">
            Eén heldere prijs. Of bespaar met een 3-pack.
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {/* Single */}
          <div className="bg-white rounded-oc border border-oc-border shadow-oc-card overflow-hidden flex flex-col">
            <div className="bg-oc-primary text-white p-8 sm:p-10 text-center">
              <p className="text-[13px] uppercase tracking-[0.1em] text-white/70 font-semibold">Per analyse</p>
              <p className="font-mono font-semibold mt-3 text-[56px] sm:text-[64px] leading-none text-white">€4,99</p>
              <p className="mt-3 text-white/80 text-[14px]">Eenmalig — BTW inbegrepen</p>
            </div>
            <div className="p-8 sm:p-10 flex flex-col flex-1">
              <ul className="space-y-3">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-[15px] text-oc-textPrimary">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-oc-fair/15 text-oc-fair flex items-center justify-center shrink-0">
                      <Check className="w-3 h-3" strokeWidth={3} />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/analyse" className="block mt-9 mt-auto pt-9">
                <Button
                  data-testid="pricing-cta-single"
                  className="w-full bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-13 text-[15px] font-semibold transition-all hover:scale-[1.01]"
                >
                  Start mijn analyse
                </Button>
              </Link>
            </div>
          </div>

          {/* Bundle — featured */}
          <div className="relative bg-white rounded-oc border-2 border-oc-secondary shadow-oc-card-hover overflow-hidden flex flex-col">
            <span className="absolute top-4 right-4 z-10 bg-oc-secondary text-white text-[11px] uppercase tracking-[0.1em] font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5">
              <Coins className="w-3 h-3" /> Populair · bespaar 33%
            </span>
            <div className="bg-gradient-to-br from-oc-primary to-oc-secondary text-white p-8 sm:p-10 text-center">
              <p className="text-[13px] uppercase tracking-[0.1em] text-white/70 font-semibold">3-pack bundle</p>
              <p className="font-mono font-semibold mt-3 text-[56px] sm:text-[64px] leading-none text-white">€9,99</p>
              <p className="mt-3 text-white/80 text-[14px]">3 analyses · gem. € 3,33 per analyse</p>
            </div>
            <div className="p-8 sm:p-10 flex flex-col flex-1">
              <ul className="space-y-3">
                {bundleFeatures.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-[15px] text-oc-textPrimary">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-oc-secondary/15 text-oc-secondary flex items-center justify-center shrink-0">
                      <Check className="w-3 h-3" strokeWidth={3} />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/analyse?bundle=1" className="block mt-9 mt-auto pt-9">
                <Button
                  data-testid="pricing-cta-bundle"
                  className="w-full bg-oc-secondary hover:bg-oc-primary text-white rounded-oc-btn h-13 text-[15px] font-semibold transition-all hover:scale-[1.01]"
                >
                  Koop 3-pack
                </Button>
              </Link>
              <Link to="/credits" className="block text-center mt-3 text-[13px] text-oc-textSecondary hover:text-oc-primary">
                Al een 3-pack? Wissel je credit in →
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 max-w-2xl mx-auto bg-white rounded-oc border border-oc-border p-6 sm:p-7">
          <div className="flex items-center justify-center gap-2 text-oc-textSecondary text-[13px]">
            <Lock className="w-3.5 h-3.5" />
            Beveiligd betalen via MultiSafepay · 256-bit encryptie
          </div>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {methods.map((m) => (
              <span
                key={m}
                className="px-3 py-1 rounded-md bg-oc-subtle border border-oc-border text-[12px] font-medium text-oc-textSecondary"
              >
                {m}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
